import { FunctionComponent as F } from "react";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from "@mui/material/Box";
import { MenuItem, Menu } from "@mui/material";
import { bindMenu, PopupState } from 'material-ui-popup-state/hooks'
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector } from 'react-redux';
import { IState } from "../../core/store/store";
import ShareIcon from '@mui/icons-material/Share';
import DuplicateProtocol from "./DuplicateProtocol";
import EditIcon from '@mui/icons-material/Edit';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";


interface Props
{
  protocolId: number,
  setMoveToFolderDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setRemoveDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  popupState: PopupState,
  showDuplicateWarningDialog: () => void,
  showRenameDialog: () => void,
  openShareDialog: () => void
}

const ProtocolListItemMenu: F<Props> = (props: Props) =>
{
  const protocols = useSelector((state: IState) => state.protocol.protocols);
  const protocol = protocols.find(p => p.protocolId === props.protocolId);
  const user = useSelector((state: IState) => state.user);

  if(!protocol)
    return <></>;

  const sharedWithMe = protocol?.sharedWith.find(p => p.userId === user.userId);
  const owned = protocol.userId === user.userId;
  const multipleProtocols = protocols.filter(p => p.userId === user.userId).length > 1;

  return (
    <Menu {...bindMenu(props.popupState)} autoFocus={false} disableAutoFocusItem={true}>

      {owned ?
        <MenuItem onClick={() => { props.popupState.close(); props.showRenameDialog(); }}>
          <ListItemIcon>
            <EditIcon fontSize='small'/>
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'body2' }}>Rename</ListItemText>
        </MenuItem> :
        <Box/>}

      {(owned && user.premium) ?
        <MenuItem onClick={() => { props.popupState.close(); props.setMoveToFolderDialog(true) }}>
          <ListItemIcon>
            <DriveFileMoveIcon fontSize='small'/>
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'body2' }}>Move to folder...</ListItemText>
        </MenuItem> :
        <Box/>}

      {(user.premium || sharedWithMe) ?
        <DuplicateProtocol
          protocolId={props.protocolId}
          popupState={props.popupState}
          showDuplicateWarningDialog={props.showDuplicateWarningDialog}/>  :
        <Box/>}

      {(owned && multipleProtocols) ?
        <MenuItem onClick={() => { props.popupState.close(); props.setDeleteDialog(true) }}>
          <ListItemIcon>
            <DeleteIcon fontSize='small'/>
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'body2' }}>Delete</ListItemText>
        </MenuItem> :
        <Box/>}

      {sharedWithMe ?
        <MenuItem onClick={() => { props.popupState.close(); props.setRemoveDialog(true) }}>
          <ListItemIcon>
            <RemoveCircleIcon fontSize='small'/>
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'body2' }}>Remove</ListItemText>
        </MenuItem> :
        <Box/>}

      {(user.username && owned) ?
        <MenuItem onClick={() =>
        {
          props.popupState.close();
          props.openShareDialog();
        }}>
          <ListItemIcon>
            <ShareIcon
              fontSize='small'
              color={(protocol.public || protocol.sharedWith.length) ? 'primary' : 'inherit'}/>
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'body2' }}>Share</ListItemText>
        </MenuItem> :
        <Box/>}

    </Menu>);
}

export default ProtocolListItemMenu;

